import { useEffect } from "react";
import { useMatch } from "react-router-dom";
import { useHeader } from "../contexts/HeaderContext";
import { useView } from "../contexts/ViewContext";
import { ROUTES } from "../routes";

export const ProgressSync = () => {
    const { view } = useView();
    const { setProgress, setProgressRequested } = useHeader();
    const onReviewStep = useMatch(ROUTES.LEARNING_JOURNEY_STEP);

    useEffect(() => {
        if (onReviewStep) return;
        const hasProgress = view?.progress != null;
        setProgressRequested(hasProgress);
        setProgress(hasProgress ? view.progress : null);
    }, [view, onReviewStep, setProgress, setProgressRequested]);

    return null; // this component doesn't render anything
}
